export default __webpack_public_path__ + "static/media/BG_Page_03.71301029.svg";